import { DebtLetterDetails } from 'api/Api';

export class PrintDocumentViewModel {
    constructor(readonly recoveries: DebtLetterDetails[]) {}
}
